const LOAD_TYPES = {
  PALLET: 'PALLET',
  BULK: 'BULK',
  PARCEL: 'PARCEL',
  NON_PALLETIZED: 'NON_PALLETIZED',
};
const BUTTON_TYPES = {
  PALLET: 'PALLET_BUTTON',
  NON_PALLETIZED: 'NON_PALLETIZED_BUTTON',
};

const PALLET_SIZES = {
  EU_PALLET: {
    item_width: 80,
    item_length: 120,
  },
  US_PALLET: {
    item_width: 100,
    item_length: 120,
  },
};

const NON_PALLET_SIZES = {
  PARCEL_STANDART: {
    item_width: 40,
    item_length: 60,
    item_height: 40,
  },
};

const PALLET_TYPES = {
  EU_PALLET: 'EU_PALLET',
  US_PALLET: 'US_PALLET',
  CUSTOM_PALLET: 'CUSTOM_PALLET',
};

const NON_PALLETIZED_TYPES = {
  PARCEL_STANDART: 'PARCEL_STANDART',
  PARCEL_CUSTOM: 'PARCEL_CUSTOM',
  BULK: 'BULK',
};

const FIELDS = {
  ITEM_HEIGHT: 'item_height',
  TOTAL_WEIGHT: 'total_weight',
  ITEM_WIDTH: 'item_width',
  ITEM_LENGTH: 'item_length',
  NUMBER_OF_ITEMS: 'number_of_items',
  PALLET_TYPE: 'pallet_type',
  LOAD_TYPE: 'load_type',
};

const FIELDS_CONFIG = {
  [FIELDS.ITEM_HEIGHT]: {
    UNIT: 'cm',
    MIN: 20,
    MAX: 270,
  },
  [FIELDS.ITEM_WIDTH]: {
    UNIT: 'cm',
    MIN: 20,
    MAX: 240,
  },
  [FIELDS.ITEM_LENGTH]: {
    UNIT: 'cm',
    MIN: 20,
    MAX: 1000,
  },
  [FIELDS.TOTAL_WEIGHT]: {
    UNIT: 'kg',
    MIN: 0,
    MAX: null, //max total weight comes from api settings
  },
};

const MAX_NUMBER_OF_PALLETS_PER_TYPE = {
  EU_PALLET: 33,
  US_PALLET: 26,
};

const MAX_UNITS_TO_CONVERT_CM_TO_M = 250;

const LENGTH_UNITS = {
  CENTIMETRES: 'cm',
  METRES: 'm',
};

export default {
  LOAD_TYPES,
  PALLET_SIZES,
  NON_PALLET_SIZES,
  PALLET_TYPES,
  NON_PALLETIZED_TYPES,
  FIELDS,
  FIELDS_CONFIG,
  MAX_NUMBER_OF_PALLETS_PER_TYPE,
  MAX_UNITS_TO_CONVERT_CM_TO_M,
  LENGTH_UNITS,
  BUTTON_TYPES,
};
